module.exports = __webpack_public_path__ + "img/brasil.svg.2020_08_12_22_43_13.0.cb82366c.svg";